<template>
    <div>
        <p class="title">{{ title }}</p>
        <p class="explanation" v-if="explanation">{{ explanation }}</p>
    </div>
    
</template>

<script>
export default {
    name: 'TitleAndExplanation',
    props: {
        title: {
            type: String,
            required: true
        },
        explanation: {
            type: String,
            required: false,
            default: ''
        }
    }
}
</script>

<style scoped>
    .title {
        font-size: 24px;
        font-weight: var(--font-weight-bold);
        line-height: 36px;
        margin:0;
    }
    .explanation {
        font-size: var(--font-size-inputs);
        font-weight: 500;
        line-height: 24px;
        margin: 0 0 20px;
        padding-top: 8px;
    }
</style>